export const calculateHeight = ({
  panelHeight = 300,
  nonScheduledProductsCount = 0,
  note = '',
  companyLength = 0,
} = {}) => {
  // default height of the panel is 300 pixels
  let calculatedPanelHeight = panelHeight

  // if there isn't any or there is one non scheduled product, no substruction from the panel height
  // if there are 2 non scheduled products, substract 40 pixels from the panel height
  // if there are 3 or more non scheduled products, substract 80 pixels from the panel height
  const substractNonScheduledProductsHeight =
    nonScheduledProductsCount < 2 ? 0 : nonScheduledProductsCount === 2 ? 40 : 80

  // if there is note and the length of the note is less than 60 characters, substract 40 pixels from the panel height
  // if there is not and the length of the note is more than 60 characters, substract 80 pixels from the panel height
  // otherwise, no substraction
  const substractNoteHeight = note ? (note.length < 60 ? 40 : 80) : 0

  // If there isn't company, then 40 pixels will be added to the panel height
  const addBookingDetailsCompanyHeight = companyLength > 0 ? 0 : 40

  calculatedPanelHeight =
    calculatedPanelHeight - substractNonScheduledProductsHeight - substractNoteHeight

  return calculatedPanelHeight + addBookingDetailsCompanyHeight
}
